<template>
  <sc-chart :options="chartData" />
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { ScChart } from '@intelipost-js/secure-components';

  const { mapState } = createNamespacedHelpers('analytic/performance');

  export default {
    name: 'sc-report-chart',
    computed: {
      ...mapState([
        'reportData',
      ]),
      summaries() {
        return (this.reportData && this.reportData.summary) ? this.reportData.summary : [];
      },
      providers() {
        return this.summaries.map(item => item.logistic_provider_name);
      },
      inTime() {
        return this.summaries.map(item => item.percentage * 100.0);
      },
      outOfTime() {
        return this.summaries.map(item => (1.0 - item.percentage) * 100.0);
      },
      averagePercentage() {
        return this.summaries.map(() => this.reportData.total_percentage * 100);
      },
      chartData() {
        return {
          chart: {
            type: 'column',
          },
          title: {
            text: '',
          },
          xAxis: {
            categories: this.providers,
          },
          yAxis: {
            min: 0,
            title: {
              text: '',
            },
          },
          plotOptions: {
            column: {
              stacking: 'percent',
            },
          },
          tooltip: {
            backgroundColor: 'white',
            useHTML: true,
            headerFormat: '<h3>{point.key}</h3>',
            pointFormat: '<span style="color:{series.color};font-weight:bold;">{series.name}: {point.percentage:.0f}%</span><br/>',
            shared: true,
          },
          series: [
            {
              name: 'Atrasado',
              data: this.outOfTime,
              color: '#da6f6f',
            },
            {
              name: 'No Prazo',
              data: this.inTime,
              color: '#a4c25c',
            },
            {
              type: 'line',
              name: 'Média geral',
              data: this.averagePercentage,
              marker: {
                enabled: false,
              },
              states: {
                hover: {
                  lineWidth: 2,
                },
              },
              enableMouseTracking: false,
            },
          ],
        };
      },
    },
    components: {
      ScChart,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/performance/components/sc-report-performance-chart/ScReportPerformanceChart.vue?5cb44c85